import { useDispatch, useSelector } from 'react-redux';
import { Grid } from '@mui/material';
import { useForm } from 'react-hook-form';

import validators from 'utils/validators';
import FormCard from 'components/FormCard';
import AnimateButton from 'components/@extended/AnimateButton';
import Button from 'components/Button';
import React, { useEffect } from 'react';
import * as actions from 'reducers/produtosAtividades.reducer';
import Loader from 'components/Loader';
import MainCard from 'components/MainCard';
import { Box, Typography } from '@mui/material';
import MainLayout from 'layout/MainLayout/index';

import {
  actions as routeActions,
  types as routes
} from 'reducers/rotas.actions';
import DadosDaAtividade from './DadosDaAtividade';

const Atividade = () => {
  const dispatch = useDispatch();
  const produto = useSelector(
    (state) => state.produtosAtividades.atividade.data
  );
  const loading = useSelector(
    (state) => state.produtosAtividades.atividade.loading
  );

  const idOperacao = useSelector(
    (state) => state.produtosAtividades.idOperacao
  );
  const idEtapa = useSelector((state) => state.produtosAtividades.idEtapa);

  const isEditMode = useSelector(
    (state) => state.produtosAtividades.atividade.isEditMode
  );

  const produtoEtapa = useSelector((state) => state.produtosEtapas.etapa.data);
  const produtoOperacao = useSelector((state) => state.produtos.produto.data);

  let disabled =
    (isEditMode && produto?.tipoSituacao !== 'A') ||
    produtoOperacao?.tipoSituacao !== 'A' ||
    produtoEtapa?.tipoSituacao !== 'A';

  const initialValues = {
    // Dados do Atividade
    nomeAtividade: produto?.nomeAtividade ?? '',
    ordemAtividade: produto?.ordemAtividade ?? '',
    diasSla: produto?.slaDias ?? ''
  };

  const rules = {
    // Dados do Atividade
    nomeAtividade: validators.string({ required: true }),
    ordemAtividade: validators.number({ required: true, min: 0, max: 32767 }),
    diasSla: validators.number({ required: true, min: 0, max: 32767 })
  };

  const formProps = {
    ...useForm(),
    rules,
    initialValues: {
      ...initialValues
    },
    defaultValues: produto
  };

  useEffect(() => {
    if (!!produto) {
      formProps.reset({
        ...produto
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [produto]);

  const handleSubmit = (values) => {
    const payload = {
      ...values,
      dataAlteracao: new Date().toISOString(),
      dataCriacao: new Date().toISOString(),
      idOperacao,
      idEtapa,
      tipoSituacao: 'A'
    };

    if (isEditMode) {
      dispatch(actions.editarAtividadeRequest({ value: payload }));
    } else {
      dispatch(actions.criarAtividadeRequest({ value: payload }));
    }
  };

  const handleGoBack = () => {
    dispatch(
      routeActions.redirectTo(routes.PRODUTO_ATIVIDADES, {
        idOperacao,
        idEtapa
      })
    );
  };

  if (loading) {
    return (
      <MainLayout>
        <Loader />
      </MainLayout>
    );
  }

  if (isEditMode && !produto?.idAtividade) {
    return (
      <MainLayout>
        <>
          <MainCard border={false} title={'Atividade não encontrada'}>
            <Grid
              container
              style={{ marginTop: 20, justifyContent: 'end', marginBottom: 20 }}
              spacing={2}
            >
              <Grid item xs={12} md={4}>
                <AnimateButton>
                  <Button
                    disableElevation
                    fullWidth
                    size="large"
                    type="button"
                    variant="outlined"
                    color="secondary"
                    onClick={handleGoBack}
                  >
                    VOLTAR
                  </Button>
                </AnimateButton>
              </Grid>
            </Grid>
          </MainCard>
        </>
      </MainLayout>
    );
  }

  return (
    <MainLayout>
      <form noValidate onSubmit={formProps.handleSubmit(handleSubmit)}>
        <MainCard
          contentSX={{
            paddingLeft: 1,
            paddingRight: 1
          }}
          border={false}
          title={
            !isEditMode ? (
              'Nova Atividade'
            ) : (
              <Box>
                <Typography variant="h2">{produto?.nomeAtividade}</Typography>
                <Typography variant="subtitle1" color="textSecondary">
                  Atividade
                </Typography>
              </Box>
            )
          }
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              gap: 2
            }}
          >
            <Box sx={{ flex: 1 }}>
              <FormCard title="DADOS DA ATIVIDADE" style={{ flex: 1 }}>
                <DadosDaAtividade formProps={formProps} disabled={disabled} />
              </FormCard>
            </Box>
          </Box>
        </MainCard>

        <Grid
          container
          style={{ marginTop: 20, justifyContent: 'end', marginBottom: 20 }}
          spacing={2}
        >
          <Grid item xs={12} md={4}>
            <AnimateButton>
              <Button
                disableElevation
                fullWidth
                size="large"
                type="button"
                variant="outlined"
                color="secondary"
                onClick={handleGoBack}
              >
                VOLTAR
              </Button>
            </AnimateButton>
          </Grid>
          <Grid item xs={12} md={4}>
            <AnimateButton>
              <Button
                disabled={disabled}
                disableElevation
                fullWidth
                size="large"
                variant="contained"
                color="primary"
                type="submit"
              >
                SALVAR
              </Button>
            </AnimateButton>
          </Grid>
        </Grid>
      </form>
    </MainLayout>
  );
};

export default Atividade;
